module.exports = __webpack_public_path__ + "static/media/cancelled.5ce3a9bf.svg";